import { NgModule } from '@angular/core';
import { SiteCommonModule } from '@widgets/site-common/site-common.module';
import { ExtraLoadModalComponent } from './extra-load-modal.component';
import { LoadInformationComponent } from './load-information/load-information.component';
import { AttachDocumentsComponent } from './attach-documents/attach-documents.component';

@NgModule({
  declarations: [ExtraLoadModalComponent, LoadInformationComponent, AttachDocumentsComponent],
  exports: [ExtraLoadModalComponent],
  imports: [SiteCommonModule]
})
export class ExtraLoadModalModule {}
